<template>
  <v-card class="mt-3">
    <v-card-title>Tempo de primeira resposta após transbordo (TPR)</v-card-title>

    <v-card-text>
      <v-expand-transition>
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </v-expand-transition>

      <v-expand-transition>
        <v-data-table
          :headers="headers"
          :items="loading ? [] : temposDePrimeirasRespostasAposTransbordo"
          class="elevation-2"
          no-data-text="Nenhum atendimento disponível"
          :footer-props="{
            'items-per-page-text': 'Atendimentos por página',
            'page-text': '{0}-{1} de {2}',
            'items-per-page-all-text': 'Todos',
          }"
        >
          <template #item.agenteNome="{ item }">
            <td>
              <v-avatar
                :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
                size="32"
              >
                <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
                  {{ item.agenteNome.toUpperCase().charAt(0) }}{{ item.agenteNome.toUpperCase().charAt(1) }}
                </span>
              </v-avatar>
              <span class="ms-2">
                {{ item.agenteNome }}
              </span>
            </td>
          </template>

          <template #item.protocolo="{ index, item }">
            <v-chip
              :color="index % 2 === 0 ? 'accent' : 'primary'"
              outlined
            >
              {{ item.protocolo }}
            </v-chip>
          </template>

          <template #item.tempoDePrimeiraResposta="{ item }">
            <v-chip
              :color="item.tempoDePrimeiraResposta != null ? 'success' : 'warning'"
              outlined
            >
              {{ item.tempoDePrimeiraResposta != null ? formatTime(item.tempoDePrimeiraResposta) : 'Não respondido' }}
            </v-chip>
          </template>
        </v-data-table>
      </v-expand-transition>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatTime } from '@/utils/time'

export default {
  props: {
    temposDePrimeirasRespostasAposTransbordo: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const headers = [
      { text: 'Agente', value: 'agenteNome' },
      { text: 'Protocolo', value: 'protocolo' },
      { text: 'Tempo de primeira resposta', value: 'tempoDePrimeiraResposta' },
    ]

    return {
      headers,
      formatTime,
    }
  },
}
</script>
